import { PromotionBulkValidateRes } from './types'

// 등록되지 않은 업체아이디를 화면에서 거른다 (LOGISPRD-11448).
// mass 에는 파트너 마스터가 없어 BE 가 실존을 못 본다 — 단건 등록은 셀렉트가 목록을 강제하는데
// 일괄등록만 엑셀 문자열이 그대로 통과해, 어느 정산 라인에도 안 붙는 죽은 프로모션이 등록된다.
// 목록을 못 받았으면(조회 실패·미도착) 거르지 않는다 — 조회 장애로 업로드 전체가 막히는 쪽이 더 나쁘다
export const withUnknownPartnerErrors = (result: PromotionBulkValidateRes, knownPartners: Set<string>): PromotionBulkValidateRes => {
  if (knownPartners.size === 0) return result
  const rows = result.rows.map((row) => {
    const unknown = (row.value.partnerIds ?? []).filter((partnerId) => !knownPartners.has(partnerId))
    if (unknown.length === 0) return row
    return {
      ...row,
      valid: false,
      errors: [...row.errors, { field: 'partnerIds', code: 'UNKNOWN_PARTNER', message: `등록되지 않은 업체아이디입니다 (${unknown.join(', ')})` }],
    }
  })
  const invalid = rows.filter((row) => !row.valid).length
  return { ...result, rows, summary: { ...result.summary, valid: rows.length - invalid, invalid } }
}
